import React from 'react';
import DesktopSearchBar from './DesktopSearchBar';
import MobileSearchBar from './MobileSearchBar';
import ProviderSelector from './ProviderSelector';

import css from './MainFiltersForm.css';

const ResponsiveSwitcher = props => {
  return (
    <>
      <div className={css.desktopOnly}>
        <DesktopSearchBar {...props} />
        {props.displayProviderFilter && <ProviderSelector {...props} />}
      </div>
      <div className={css.mobileOnly}>
        <MobileSearchBar {...props} />
      </div>
    </>
  );
};

export default ResponsiveSwitcher;
